import React, { useEffect, useState, useMemo, useCallback } from 'react';
import EditorComponent from '../components/Template/Editor';
import { Tooltip } from 'react-tooltip';
import Dropdown from 'react-select';
import services from '../services';
const ReplyDropdown = ({
    draftBody,
    emailValue,
    cc,
    bcc,
    showCc,
    showBcc,
    setShowCc,
    setShowBcc,
    handleEmailChange,
    handleCcChange,
    handleBccChange,
    replyDropdown,
    setReplyDropdown,
    isForward,
    isReply,
    templateselect,
    setTemplateselect,
    allTemp,
    template,
    setTemplate,
    setTextAreaValue,
    visibleReplies,
    selectedMail,
    isReplyloading,
    createTask,
    handleFileChange,
    uploadedFiles,
    handleRemoveFile,
    handleDelete,
    setShowBccCc,
    getemailbyid,
    childTaskData,
    mode,
    idx,
    saveDrafts,
    submitData,
    setSubmitData,
    draftidx
}) => {
    const [folder, setFolder] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState('');
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState('English');
    const [localAllTemp, setLocalAllTemp] = useState([]);

    const getAvailableLanguages = useCallback((languages) =>
        Object.entries(languages)
            .filter(([_, data]) => data.subject.trim() || data.body.trim())
            .map(([lang]) => ({ value: lang, label: lang }))
        , []);

    const normalizeTemplateLanguages = (t) => ({
        English: {
            subject: t.subject || '',
            body: t.body || ''
        },
        French: {
            subject: t.frenchSubject || '',
            body: t.frenchBody || ''
        },
        German: {
            subject: t.germanSubject || '',
            body: t.germanBody || ''
        },
        Portuguese: {
            subject: t.portugueseSubject || '',
            body: t.portugueseBody || ''
        },
        Spanish: {
            subject: t.spanishSubject || '',
            body: t.spanishBody || ''
        }
    });

    const folderOptions = useMemo(() => {
        const options = folder.map((f) => ({
            value: f.id,
            label: f.name,
            Templates: f.Templates || [],
        }));
        return [{ value: "", label: "Select template folder", Templates: [] }, ...options];
    }, [folder]);

    const selectedFolderOption = useMemo(() => {
        return folderOptions.find((f) => f.value === selectedFolder) || null;
    }, [folderOptions, selectedFolder]);

    const selectedTemplateOption = useMemo(() => {
        return localAllTemp.find((t) => t.value === templateselect) || null;
    }, [localAllTemp, templateselect]);

    const memoizedHandleEditorChange = useCallback((data) => {
        setTextAreaValue((prev) => {
            if (prev === data) return prev;
            return data;
        });
    }, [setTextAreaValue]);

    const memoizedEditorPrevData = useMemo(() => ({ templateData: template?.templateData }), [template?.templateData]);

    const getTemplate = async () => {
        try {
            const response = await services.template.GET_ALL_TEMPLATE();

            // Get user access info
            let raw = localStorage.getItem("userData");
            let storedData = {};
            try {
                const parsedOnce = JSON.parse(raw);
                storedData = typeof parsedOnce === "string" ? JSON.parse(parsedOnce) : parsedOnce;
            } catch (err) {
                console.error("Parsing error:", err);
            }

            const role = storedData?.role?.toLowerCase();
            const privileges = storedData?.privileges || storedData?.Group?.privileges || {};
            const allowedFolders = privileges?.emailTemplateFolders || [];

            if (response && Array.isArray(response.templates) && response.templates.length > 0) {
                let filteredTemplates = response.templates.filter(item => item.status === true);

                // Filter by folder access if not admin
                if (role !== "admin") {
                    filteredTemplates = filteredTemplates.filter(item =>
                        !item.folderId || allowedFolders.includes(item.folderId)
                    );
                }

                const mappedTemplates = filteredTemplates.map(item => ({
                    label: item.name || '',
                    value: item.id || '',
                    languages: normalizeTemplateLanguages(item) || {},
                    displayValue: (item.body || '').replace(/\n/g, ' ')
                }));
                setLocalAllTemp([{ value: "", label: "Select template", languages: {} }, ...mappedTemplates]);
            } else {
                setLocalAllTemp([]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getTemplateFolder = async () => {
        try {
            const res = await services.template.GET_ALL_FOLDER();
            const sorted = (res || []).sort(
                (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
            );

            let raw = localStorage.getItem("userData");
            let storedData = {};

            try {
                const parsedOnce = JSON.parse(raw);
                storedData =
                    typeof parsedOnce === "string"
                        ? JSON.parse(parsedOnce)
                        : parsedOnce;
            } catch (err) {
                console.error("Parsing error:", err);
            }

            const role = storedData?.role?.toLowerCase();
            const privileges = storedData?.privileges || storedData?.Group?.privileges || {};

            if (role === "admin") {
                setFolder(sorted);
            } else {
                const allowedFolders = privileges?.emailTemplateFolders || [];
                setFolder(sorted.filter(folder =>
                    folder.name === "Shared with all" || allowedFolders.includes(folder.id)
                ));
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getTemplateFolder();
        getTemplate();
    }, []);

    return (
        <>
            {!replyDropdown ? null : (
                <div
                    style={{ marginBottom: '10%' }}
                    className={`ml-[20px] md:ml-[3.5rem] replydropdown mailreply-dropbox ${replyDropdown ? 'open' : ''
                        } kanban-dropDown text-black`}
                >
                    <div className="bg-white p-4" style={{
                        boxShadow:
                            'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
                        borderRadius: '10px',
                    }}>
                        <div>
                            <div className="w-full flex flex-col md:flex-row items-start justify-between mb-4">
                                <div className="flex flex-wrap items-center gap-[10px] md:gap-[15px]">
                                    <div onClick={() => setReplyDropdown(false)}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            fill="none"
                                            stroke="#444"
                                            strokeWidth="1.5"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                d="M10 19l-7-7 7-7"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M3 12h13a6 6 0 0 1 6 6v1"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>

                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill text-black"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>

                                    <div className="flex items-center flex-nowrap gap-2 min-w-0 flex-1">
                                        <span className="text-[14px] opacity-50 capitalize text-[#000] whitespace-nowrap">
                                            Recipients
                                        </span>
                                        <input
                                            type="email"
                                            className="h-10 flex-1 border text-gray-900 focus:outline-none px-3 rounded input-border"
                                            value={emailValue}
                                            onClick={() => setShowBccCc(true)}
                                            onChange={handleEmailChange}
                                            placeholder="Enter email"
                                        />
                                    </div>
                                </div>


                                <div className="flex gap-[10px] text-sm cursor-pointer text-gray-600 mt-2 md:mt-0">
                                    {saveDrafts && (
                                        <span className="text-sm text-gray-500">{saveDrafts} </span>
                                    )}
                                    {!showCc && (
                                        <span onClick={() => setShowCc(true)} className="hover:underline">
                                            Cc
                                        </span>
                                    )}
                                    {!showBcc && (
                                        <span onClick={() => setShowBcc(true)} className="hover:underline">
                                            Bcc
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div >
                            {showCc && (
                                <div className="flex items-center gap-3 mb-2" >
                                    <label className="text-[14px] opacity-70 text-black ">Cc</label>
                                    <input
                                        type="email"
                                        className="flex-1 h-10 border border-gray-300 rounded-md p-3 text-gray-900 text-sm ml-[7px]  "
                                        value={cc}
                                        onChange={handleCcChange}
                                        placeholder="Cc"
                                    />
                                </div>
                            )}

                            {showBcc && (
                                <div className="flex items-center gap-3 mb-2" >
                                    <label className="text-[14px] opacity-70 text-black ">Bcc</label>
                                    <input
                                        type="email"
                                        className="flex-1 h-10 border border-gray-300 rounded-md p-3 text-gray-900 text-sm  "
                                        value={bcc}
                                        onChange={handleBccChange}
                                        placeholder="Bcc"
                                    />
                                </div>
                            )}

                        </div>
                        <div
                            className="bg-[#FAFAFA] border border-[#EAEAEA] rounded-[4px]"
                        >

                            <div className="mb-4 flex space-x-4">
                                <div className="flex-1">
                                    <label className="block text-sm font-medium mb-1">
                                        Select Template Folder
                                    </label>

                                    <Dropdown
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                                scrollbarWidth: "none",          // ensure dropdown is on top
                                                overflowY: 'auto',
                                            }),
                                        }}
                                        value={selectedFolderOption}
                                        options={folderOptions}
                                        className="block border rounded-md text-sm"

                                        placeholder="Search folder..."
                                        onChange={(option) => {
                                            if (!option) return;

                                            if (option.value === "") {
                                                getTemplate();
                                                setSelectedFolder("");
                                                setTemplateselect("");
                                                setSelectedLanguage("");
                                                setAvailableLanguages([]);
                                                setTemplate({ templateData: "" });
                                                return;
                                            }

                                            setSelectedFolder(option.value);
                                            setTemplateselect("");
                                            setSelectedLanguage("");
                                            setAvailableLanguages([]);

                                            const templates =
                                                option.Templates?.map((t) => ({
                                                    value: t.id,
                                                    label: t.name,
                                                    languages: normalizeTemplateLanguages(t) || {},
                                                })) || [];

                                            setLocalAllTemp([{ value: "", label: "Select template", languages: {} }, ...templates]);
                                            setTemplate({ templateData: "" });
                                        }}
                                    />


                                </div>

                                {/* ================= Template ================= */}
                                <div className="flex-1">
                                    <label className="block text-sm font-medium mb-1">
                                        Template
                                    </label>

                                    <Dropdown
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                                scrollbarWidth: "none",          // ensure dropdown is on top
                                                overflowY: 'auto',
                                            }),
                                        }}
                                        className=" w-full  border rounded-md text-sm"

                                        value={selectedTemplateOption}
                                        options={localAllTemp}
                                        placeholder="Search template..."
                                        disabled={!selectedFolder}
                                        onChange={(option) => {
                                            if (!option) return;

                                            setTemplateselect(option.value);

                                            if (option.value === "") {
                                                setSelectedLanguage("");
                                                setAvailableLanguages([]);
                                                setTemplate({ templateData: "" });
                                                return;
                                            }

                                            const langs = getAvailableLanguages(option.languages);
                                            setAvailableLanguages(langs);

                                            const defaultLang = langs.length ? langs[0].value : "";
                                            setSelectedLanguage(defaultLang);
                                            setTemplate({ templateData: option.languages?.[defaultLang]?.body || "" });
                                        }}
                                    />


                                </div>

                                {/* ================= Language ================= */}
                                <div className="flex-1">
                                    <label className="block text-sm font-medium mb-1">
                                        Language
                                    </label>

                                    <select
                                        className="block w-full px-3 py-2 border rounded-md text-sm"
                                        disabled={!templateselect}
                                        value={selectedLanguage}
                                        onChange={(e) => {
                                            const lang = e.target.value;
                                            setSelectedLanguage(lang);

                                            const selectedTemp = localAllTemp.find(
                                                (t) => t.value === templateselect
                                            );
                                            if (!selectedTemp) return;

                                            setTemplate({ templateData: selectedTemp.languages?.[lang]?.body || "" });
                                        }}
                                    >
                                        <option value="">Select language</option>
                                        {availableLanguages.map((lang) => (
                                            <option key={lang.value} value={lang.value}>
                                                {lang.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="w-full py-[1vw]">
                            <EditorComponent
                                mode={mode}
                                idx={idx}
                                selectedPrevData={memoizedEditorPrevData}
                                handleEditorChange={memoizedHandleEditorChange}
                                allTemp={localAllTemp}
                                isForward={isForward}
                                isReply={isReply}
                                visibleReplies={visibleReplies}
                                selectedMail={selectedMail}
                                draftBody={draftBody}
                                draftidx={draftidx}
                                submitData={submitData}
                                setSubmitData={setSubmitData}
                            />

                            <div className="bg-[#FAFAFA] border border-[#EAEAEA] rounded-[4px] mt-2">
                                <div className="flex flex-col md:flex-row gap-[20px]" style={{ justifyContent: 'start' }}>
                                    {uploadedFiles?.length > 0 && uploadedFiles?.map((file, idx) => (
                                        <div className="bg-[#FAFAFA] p-[10px]" key={idx}>
                                            <div className="flex flex-col md:flex-row items-center gap-[20px]">
                                                <div
                                                    className="preview-container"
                                                    style={{
                                                        position: 'relative',
                                                        width: 100,
                                                        height: 100,
                                                        display: 'inline-block',
                                                        background: '#fff',
                                                        boxSizing: 'border-box',
                                                    }}
                                                >
                                                    {file.type.startsWith('image/') ? (
                                                        <img
                                                            src={URL.createObjectURL(file)}
                                                            alt={`Preview ${idx}`}
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                borderRadius: 8,
                                                                boxShadow:
                                                                    'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
                                                            }}
                                                        />
                                                    ) : (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                flexDirection: 'column',
                                                                fontSize: 32,
                                                                color: '#2196f3',
                                                                background: '#fafafa',
                                                                borderRadius: 8,
                                                            }}
                                                        >
                                                            {file.name.endsWith('.xls') || file.name.endsWith('.xlsx') ? (
                                                                <span role="img" aria-label="xls">
                                                                    📄
                                                                    <div style={{ fontSize: 12, color: '#888' }}>XLS</div>
                                                                </span>
                                                            ) : file.name.endsWith('.pdf') ? (
                                                                <span role="img" aria-label="pdf">
                                                                    📄
                                                                    <div style={{ fontSize: 12, color: '#888' }}>PDF</div>
                                                                </span>
                                                            ) : (
                                                                <span role="img" aria-label="file">
                                                                    📄
                                                                    <div style={{ fontSize: 12, color: '#888' }}>FILE</div>
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="remove-mail-box-btn"
                                                        onClick={() => handleRemoveFile(idx)}
                                                        title="Remove"
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center justify-between w-full px-4 py-2 border-t">
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={createTask}
                                    className="bg-[#1a73e8] hover:bg-[#1765c1] text-white font-semibold rounded-full px-6 py-2 text-[15px]"
                                >
                                    {isReplyloading ? 'Sending...' : 'Send'}
                                </button>
                                <label data-tooltip-id="upload-tooltip" data-tooltip-content="Attach files" style={{ cursor: 'pointer' }}>
                                    <input
                                        type="file"
                                        accept="image/*,application/pdf"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-paperclip"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                                    </svg>
                                </label>
                            </div>
                            <button onClick={handleDelete}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    className="text-gray-500"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 5h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7H6v7a.5.5 0 0 1-1 0v-7z" />
                                    <path
                                        fillRule="evenodd"
                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2H5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3a.5.5 0 0 0-.5.5V4h12v-.5a.5.5 0 0 0-.5-.5h-11z"
                                    />
                                </svg>
                            </button>
                        </div>

                        <Tooltip id="upload-tooltip" place="top" style={{ fontSize: '12px' }} />
                    </div>

                    <div className="absolute avatar-mail-span top-0">
                        <div className="w-[2.5rem] h-[2.5rem] rounded-full bg-purple-500 flex items-center justify-center text-white">
                            <span className="text-lg">
                                {selectedMail?.name?.charAt(0)?.toUpperCase() ||
                                    getemailbyid?.name?.charAt(0)?.toUpperCase() ||
                                    childTaskData?.Email?.name?.charAt(0)?.toUpperCase()}
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ReplyDropdown;
